import type {EditorState, Transaction} from "prosemirror-state";
import type {EditorView} from "prosemirror-view";

import React from 'react';

import {MuiIconExternalProps} from "../../../../components/icons/MuiIcon";
import {ContextMenuInEditor} from '../../../../components/ContextMenuInEditor';


import {editorViewRef} from '../../../../elements/EditorReact';

import {ContextMenuInterface} from "../../ContextMenuInterface";


export type ExtendedCommand = (state: EditorState, dispatch?: (tr: Transaction) => void, view?: EditorView, params?: any) => boolean;

export interface ContextAction {
    id: string;
    Icon: React.ComponentType<MuiIconExternalProps>;
    getTitle: () => string;
    action: ExtendedCommand;
    active?: ExtendedCommand,
    enable?: (state: EditorState, additionalParams?: any) => boolean,
    preserveContextMenu?: boolean;
}

export interface GroupedActionsProps extends ContextMenuInterface {
    actionGroups: ContextAction[][];
    additionalParams?: {};
    isInline?: boolean;
}

export const GroupedActions = (
    {
        handleClose,
        actionGroups,
        additionalParams,
        isDark,
        isInline,
    }: GroupedActionsProps
) => {
    const view = editorViewRef.current!;
    return (
        <ContextMenuInEditor
            isDark={isDark}
            itemGroups={actionGroups.map(itemGroup => itemGroup.map(ctxMenuItemLine => {
                let isActive = false;
                if (ctxMenuItemLine.active) {
                    isActive = ctxMenuItemLine.active(view.state, undefined, undefined, additionalParams);
                }
                return ({
                    ...ctxMenuItemLine,
                    text: ctxMenuItemLine.getTitle(),
                    isActive: isActive,
                    onClick: () => {
                        const result = ctxMenuItemLine.action(view.state, view.dispatch, view, additionalParams);
                        if (result) {
                            view.focus();
                            return true;
                        } else {
                            return result;
                        }
                    }
                })
            }))}
            handleClose={handleClose}
            isInline={isInline}
        />
    )
}
